import { datadogRum } from '@datadog/browser-rum';
import { Box } from '@spark-web/box';
import { ButtonLink } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { ArrowCircleRightIcon } from '@spark-web/icon';
import { Row } from '@spark-web/row';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { CUSTOMER_PORTAL_APPROVED, getCustomerPortalUrl } from '../../utils';
import { ApplicationSubmissionStatus } from './types';

type CustomerPortalCardApprovedProps = {
  readonly applicationStatus: ApplicationSubmissionStatus;
};

// Separate from CustomerPortalCard rather than a variant of it, so the approved banner can change
// freely without touching the under-review one.
function CustomerPortalCardApproved({ applicationStatus }: CustomerPortalCardApprovedProps) {
  const handleClick = () => {
    datadogRum.addAction('customer_portal_handoff_started', { applicationStatus });
  };

  return (
    <Box background="primaryLow" borderRadius="medium" padding="xxlarge">
      <Stack gap="xlarge">
        {/* Same responsive-heading swap as PageTitle: keeps a single <h2> in the a11y tree at any size. */}
        <Box display={{ mobile: 'none', tablet: 'block' }}>
          <Heading level="2">{CUSTOMER_PORTAL_APPROVED.HEADING}</Heading>
        </Box>
        <Box display={{ mobile: 'block', tablet: 'none' }}>
          <Heading as="h2" level="3">
            {CUSTOMER_PORTAL_APPROVED.HEADING}
          </Heading>
        </Box>
        <Stack gap="small">
          {CUSTOMER_PORTAL_APPROVED.FEATURES.map(feature => (
            <Row key={feature} gap="small" alignY="center">
              <Box flexShrink={0}>
                <ArrowCircleRightIcon size="xsmall" tone="positive" />
              </Box>
              <Text>{feature}</Text>
            </Row>
          ))}
        </Stack>
        <Box display="flex" justifyContent={{ mobile: 'center', tablet: 'start' }}>
          <ButtonLink
            href={getCustomerPortalUrl()}
            onClick={handleClick}
            rounded
            target="_blank"
            rel="noreferrer"
            data={{ testId: 'go-to-customer-portal' }}
          >
            {CUSTOMER_PORTAL_APPROVED.GO_TO_CUSTOMER_PORTAL}
          </ButtonLink>
        </Box>
      </Stack>
    </Box>
  );
}

export default CustomerPortalCardApproved;
